import React, { Component } from 'react';

class Footer extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <footer id="footer" className="footer-section">
        <div className="container">

          {/* TOP */}
          <div className="footer-top text-center">
            <a className="footer-logo" href="/">
              <img
                src={publicUrl + "/assets/img/logo.png"}
                alt="logo"
                className="footer-img"
              />
            </a>

            <p className="footer-text">
              Providing advanced vascular & interventional radiology care with precision and compassion.
            </p>

            <div className="social-network">
              <a href="https://www.facebook.com/drnikhilapinjala/"><i className="icofont-facebook"></i></a>
              {/* <a href="https://twitter.com/drnikhilapinjala"><i className="icofont-twitter"></i></a> */}
              <a href="https://www.instagram.com/drnikhilapinjala_vascular/"><i className="icofont-instagram"></i></a>
              {/* <a href="#"><i className="icofont-linkedin"></i></a> */}
            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="footer-bottom text-center">
            <p>
              © 2026 All Rights Reserved {" "}
              <a href="https://ikigaihospitals.com/" target="_blank" rel="noopener noreferrer">
                Ikigai Hospitals
              </a>
              | Designed & Developed by{" "}
              <a href="https://vmedianadvertising.com/" target="_blank" rel="noopener noreferrer">
                V Media & Advertising
              </a>
            </p>
          </div>

        </div>
      </footer>
    );
  }
}

export default Footer;